/**
 * Customer copy for the approve footers' save gate — shared so StickyFooter and
 * InlineProposalFooter can never drift apart.
 */

import type { StatusBannerVariant } from '@/lib/base/banners/StatusBanner';

export interface SaveGateBanner {
  variant: StatusBannerVariant;
  title: string;
  description: string;
}

/**
 * Shown while a registered editor's latest save has failed. Approve stays
 * disabled until a background retry or a new edit saves successfully.
 */
export const SAVE_FAILED_BANNER: SaveGateBanner = {
  variant: 'error',
  title: "We couldn't save your latest changes",
  description:
    "This can't be approved until they save. Try editing again, and get in touch if it keeps happening.",
};

/** Tooltip on the disabled Approve button while a save has failed. */
export const SAVE_FAILED_TOOLTIP = "Your latest changes haven't saved yet";

/** Shown when Approve gave up waiting for saves that were still in progress. */
export const SAVE_STILL_RUNNING_BANNER: SaveGateBanner = {
  variant: 'warning',
  title: 'Your changes are still saving',
  description: 'Try approving again in a moment.',
};
